import { useTranslation } from 'react-i18next';

import './Spinner.css';

export interface SpinnerProps {
  /** Announced to screen readers and shown beside the spinner. */
  label?: string;
  size?: 'sm' | 'md';
  /** Inline spinners (inside a button) are decorative: the button announces
   * its own pending state. */
  inline?: boolean;
}

/**
 * Spinner is for a short wait whose shape is unknown. When you know what is
 * loading — a table, a row of tiles — prefer Skeleton, which holds the layout
 * still and so does not jump when the data lands.
 */
export function Spinner({ label, size = 'md', inline = false }: SpinnerProps) {
  const { t } = useTranslation('common');
  if (inline) {
    return <span className="rs-spinner__ring" data-size={size} aria-hidden="true" />;
  }
  return (
    <p className="rs-spinner" role="status" aria-live="polite">
      <span className="rs-spinner__ring" data-size={size} aria-hidden="true" />
      <span>{label ?? t('state.loading')}</span>
    </p>
  );
}
